import apiWorker from '../apiWorker'

const analytics_data_types = {

    find: (query) =>  apiWorker('get', `/api/v1/core/analytics_data_types/query${query}`),

}

export default analytics_data_types;